import React from 'react';
import PropTypes from 'prop-types';
import { Draggable } from 'react-beautiful-dnd';

class SectionItem extends React.PureComponent {
  render() {
    return (
      <Draggable
        draggableId={this.props.fieldId}
        index={this.props.index}
        isDragDisabled={!this.props.isDraggable}
      >
        {provided => (
          <React.Fragment>
            <div
              className="draggable-section-item"
              ref={provided.innerRef}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
              style={provided.draggableProps.style}
            >
              <div className="dots" />
              <div className="organization-section-item">
                {this.props.children}
              </div>
            </div>
            {provided.placeholder}
          </React.Fragment>
        )}
      </Draggable>
    );
  }
}

SectionItem.defaultProps = {
  children: null,
  isDraggable: true,
};

SectionItem.propTypes = {
  children: PropTypes.node,
  fieldId: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  isDraggable: PropTypes.bool,
};

export default SectionItem;



// WEBPACK FOOTER //
// ./src-react/SelfServePostBuilderSidePanel/SectionOrganizer/SectionItem.jsx